import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppConfig } from '../../../config/app';
import { DataApi } from '../../../providers/api-provider';
import GlobalStore from '../../../providers/global-store-provider';
import { Loader, showError } from '../libs/helpers';
import styles from './styles/login';

/* VMS Login Component */
class VMSLogin extends React.Component {
  state = {

    loading: false,
  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  componentDidMount() {
    this.performLogin();
  }
  /* API Call */
  performLogin = async () => {
    this.setState({ loading: true });
    try {
      const token = this.props.location.search.replace('?token=', '');
      Axios.defaults.headers.common['Authorization'] = "Bearer " + token;
      let res = await DataApi.getOne('auth/user');
      res.data.token = token;
      res.data.token_type = 'Bearer';
      GlobalStore.auth.login(res.data);
      this.props.history.push('/inkind-donations/create/?n');
      this.setState({ loading: false });
    } catch (e) {
      showError(e);
      this.setState({ loading: false });
    }

  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */

  /* Render Page */
  render() {
    const { classes } = this.props;
    return (
      <div>
        <main className={classes.main}>
          <CssBaseline />
          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <img alt='edSeed Logo ' src={AppConfig.base + '/logo.png?v1'} style={{ width: '95%' }} />
            </Avatar>
            <p>Logging In</p>
            <Loader size='40' />

          </Paper>

        </main>

      </div>

    );
  }
}

VMSLogin.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(VMSLogin));